import {
  Control,
  FieldValues,
  UseFormRegister,
  UseFormWatch,
} from "react-hook-form";

export enum FileClaimSteps {
  CUSTOMER_INFO = "Customer Information",
  PURCHASE_INFO = "Purchase Information",
  DAMAGE_INFO = "Damage details",
  UPLOAD_DOCUMENTS = "Upload documents",
  REVIEW_CLAIM_DETAILS = "Review claim details",
}

export const claimStepsData = [
  {
    step_num: 1,
    title: FileClaimSteps.CUSTOMER_INFO,
  },
  {
    step_num: 2,
    title: FileClaimSteps.PURCHASE_INFO,
  },
  {
    step_num: 3,
    title: FileClaimSteps.DAMAGE_INFO,
  },
  {
    step_num: 4,
    title: FileClaimSteps.UPLOAD_DOCUMENTS,
  },
  {
    step_num: 5,
    title: FileClaimSteps.REVIEW_CLAIM_DETAILS,
  },
];

export interface StepsProps<FieldsType extends FieldValues> {
  control: Control<FieldsType>;
  register: UseFormRegister<FieldsType>;
  watch: UseFormWatch<FieldsType>;
}
